import axios from 'axios';

const rawBackendUrl = process.env.REACT_APP_BACKEND_URL;
const backendUrl = rawBackendUrl && !['undefined', 'null'].includes(rawBackendUrl)
  ? rawBackendUrl.replace(/\/$/, '')
  : '';
const API_BASE_URL = process.env.NODE_ENV === 'development' || !backendUrl ? '/api' : `${backendUrl}/api`;
const AUTH_TOKEN_KEY = 'valhalla_access_token';
// Pages that work without a session and must not bounce the user to /login.
const PUBLIC_PATHS = ['/', '/login', '/gasto'];

export function getStoredAccessToken() {
  return localStorage.getItem(AUTH_TOKEN_KEY);
}

export function setStoredAccessToken(token) {
  if (token) {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
  }
}

export function clearStoredAccessToken() {
  localStorage.removeItem(AUTH_TOKEN_KEY);
}

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = getStoredAccessToken();
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const requestUrl = originalRequest?.url || '';
    const skipsRefresh = [
      '/auth/login',
      '/auth/refresh',
    ].some((path) => requestUrl.includes(path));
    
    // If 401 and not already retried, try to refresh token
    if (error.response?.status === 401 && originalRequest && !originalRequest._retry && !skipsRefresh) {
      originalRequest._retry = true;
      try {
        const refreshResponse = await api.post('/auth/refresh');
        setStoredAccessToken(refreshResponse.data?.access_token);
        return api(originalRequest);
      } catch (refreshError) {
        clearStoredAccessToken();
        if (!PUBLIC_PATHS.includes(window.location.pathname)) {
          window.location.href = '/login';
        }
        return Promise.reject(refreshError);
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;
export { api };
